module.exports = __webpack_public_path__ + "static/media/oedipoda_caerulescens.96316bbb.jpg";